import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchPendingTasksByUserIdParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchPendingTasksByUserIdApiQuery extends ApiQuery<
	TaskOutput[],
	FetchPendingTasksByUserIdParams
> {
	client = 'iam';
	document = gql`
		query FetchPendingTasksByUserId($userId: UUID!) {
			fetchPendingTasksByUserId(userId: $userId) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchPendingTasksByUserId';
}
